import { ButtonPrimary } from "components/Atoms/Button";
import { BookkeepingHeader } from "components/PurpleHeader/BookkeepingHeader";
import React from "react";
import { routes } from "utilities/routing/generatedRoutes";
import { DetailSidePanel } from "../DetailSidePanel";
import { BookkeepingSidePanelDetails } from "./BookkeepingSidePanelDetails";
import { RightClickMenu } from "components/RightClickMenu/RightClickMenuContext";
import { rightMenuForSidePanel } from "components/RightClickMenu/rightClickMenuUtils";

interface BookkeepingSidePanelProps {
  bookkeepingId: number
  trigger: JSX.Element
  fallbackIfNoPermission?: JSX.Element
}

export const BookkeepingSidePanel = (props: BookkeepingSidePanelProps) => {
  if (!site.permissions.canConfigureSystemSettings) {
    return props.fallbackIfNoPermission || props.trigger;
  }

  return <DetailSidePanel
    detailUrl={routes.bookkeeping_Detail(props.bookkeepingId).absolute}
    apiCall={() => window.CoreApi.Bookkeeping.GetSidePanelData(props.bookkeepingId)}
    apiKey="bookkeeping"
    entityId={props.bookkeepingId}
    title={RESX.Bookkeeping.resxBookkeeping}
    headerContent={data => <BookkeepingHeader bookkeeping={data.bookkeeping} />}
    footerContent={<>
      {site.permissions.canConfigureSystemSettings && <ButtonPrimary href={routes.bookkeeping_Detail(props.bookkeepingId).absolute} label={RESX.Buttons.DetailView} />}
    </>}
    trigger={<RightClickMenu menuItems={rightMenuForSidePanel(routes.bookkeeping_Detail(props.bookkeepingId).absolute)}>{props.trigger}</RightClickMenu>}
  >
    {(bookkeeping) => <BookkeepingSidePanelDetails
      bookkeeping={bookkeeping}
    />}
  </DetailSidePanel>
}